import { bootstrapApplication } from '@angular/platform-browser'

import logger from '~core/utils/logger'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

bootstrapApplication(AppComponent, appConfig).catch((err) => logger.error(err))
